export const networkProduct = {
  1: "DT",
  2: "CSTv1",
  3: "CSTv2p",
  4: "CSTv2np",
};
